<template>
    <div>
        <div class="card-container inline-block full-width">
            <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
            <div class="row-header">
                <div class="row-header-item left">Username</div>
                <div class="row-header-item middle">New Password</div>
                <div class="row-header-item middle-second">Password Saved</div>
                <div class="row-header-item right">Created By</div>
            </div>
            <div class="account-container">
                <user-account-row v-for="(user, userIndex) in userAccounts" :key="user.id" :windowWidth="windowWidth" :userAccount="user" :userIndex="userIndex" v-on:emitDeleteUserAccount="deleteUserAccount" @load-data="queryUserAccounts"></user-account-row>
            </div>
            <button class="button is-text" @click="addUser">Add User</button>
        </div>
    </div>
</template>

<script>
import store from '../store.js'
import userAPI from '@/api/UserAPI.js'
import sharedAPI from '@/api/SharedAPI.js'
import userAccountRow from '@/components/UserAccountRow'
import { mapState } from 'vuex'

export default {

    components:{
        'user-account-row' : userAccountRow
    },

    data(){
        return{
            userAccounts:[],
            isLoading: false,
            isFullPage: true,
            windowWidth: window.innerWidth
        }
    },

    watch: {
        '$route': function(){
            this.queryUserAccounts();
        }
    },

    created(){
        this.queryUserAccounts();
    },

    mounted(){
        window.onresize = () => {
            console.log(window.innerWidth)
            this.windowWidth = window.innerWidth
        }
    },

    computed: {

        ...mapState([
            'userInfo'
        ])
    },

    methods:{
        /**
         * LOADS ALL ADMIN ACCOUNTS
         */
        queryUserAccounts: async function(){
            this.isLoading = true;
            var accountsArray = [];
            var accountID = this.userInfo.accountID;
           

            try{
                if(this.$route.name=="userAccountManagementForUser"){
                    console.log("running for user");
                    var adminAccountID = this.$route.params.userID;
                    var results = await userAPI.loadspecificUserAccounts(adminAccountID);
                }
                else{
                    var results = await userAPI.loadUserAccounts(accountID);
                }
                
                var response = results.response;

                console.log(response)

                if(response == undefined){
                    this.isLoading = false;
                    this.userAccounts = [];
                    return
                }

                //FORMAT ARRAY OF INFORMATION
                response.data.forEach(value =>{
                    var accountObject = {
                        id: value.fieldData.__kptID, 
                        username: value.fieldData.username,
                        isPasswordSaved: value.fieldData.zcnIsPasswordIsSaved,
                        adminAccount: value.fieldData._kftAdminAccountID,
                        adminAccountUsername: value.fieldData.zctCreatedByUsername
                    }

                    accountsArray.push(accountObject);
                })

                this.userAccounts = accountsArray;
                this.isLoading = false;
            }
            catch(e){
                if(e.message != undefined){
                    this.$snotify.error( e.message , "Error",
                        {
                            showProgressBar: false,
                            position: 'rightBottom',
                            icon: false,
                            timeout: this.notificationDuration,
                            closeOnClick: true,
                            bodyMaxLength: 1000
                        }
                    )
                }
                else {
                    this.$snotify.error( "Could not retrieve list of admin accounts" , "Error",
                        {
                            showProgressBar: false,
                            position: 'rightBottom',
                            icon: false,
                            timeout: this.notificationDuration,
                            closeOnClick: true,
                            bodyMaxLength: 1000
                        }
                    ) 
                }
            }
        },


        addUser: function(){
            var emptyObject = {
                username: null,
                id: null,
                isPasswordSaved: false,
                adminAccount: this.userInfo.userID
            }

            this.userAccounts.push(emptyObject);
        },


        deleteUserAccount: async function(userIndex, userAccountID){
            console.log("running deletion");
            if(userAccountID == null || userAccountID == ''){
                var accounts = [...this.userAccounts];
                accounts.splice(userIndex, 1);
                this.userAccounts = [...accounts];

                return
            }
            var params = `{
                "id": "${userAccountID}"
            }`

            try{
                const result = await sharedAPI.runScript("User - Delete User Account", params);
                var scriptResult = JSON.parse(result.response.scriptResult);
                var errorCode = scriptResult.messages.code;

                if(errorCode != 0){
                    throw scriptResult.messages;
                }

                var accounts = [...this.userAccounts];
                accounts.splice(userIndex, 1);
                this.userAccounts = [...accounts];


                this.$snotify.success(`User account saved successfully`, "Success",
                    {
                        showProgressBar: false,
                        position: 'rightBottom',
                        icon: false,
                        timeout: 4000,
                        closeOnClick: true,
                        bodyMaxLength: 1000
                    }
                );
            }
            catch(e){
                this.hasErrors = true;
                if(e.message){
                    this.$snotify.error(e.message, "Error",
                    {
                        showProgressBar: false,
                        position: 'rightBottom',
                        icon: false,
                        timeout: 4000,
                        closeOnClick: true,
                        bodyMaxLength: 1000
                    }
                    )
                }
                else if(e.response.messages[0].message != undefined){
                    this.$snotify.error(e.message[0].message, "Error",
                    {
                        showProgressBar: false,
                        position: 'rightBottom',
                        icon: false,
                        timeout: 4000,
                        closeOnClick: true,
                        bodyMaxLength: 1000
                    }
                    )
                }
                else{
                    this.$snotify.error("Could not create the admin account.", "Error",
                    {
                        showProgressBar: false,
                        position: 'rightBottom',
                        icon: false,
                        timeout: 4000,
                        closeOnClick: true,
                        bodyMaxLength: 1000
                    }
                    )
                }
            }
        }
    }
}
</script>

<style scoped>
.is-active-text{
    color: #000000;
    text-decoration: underline overline;
}

.is-nav-item{
    color: #000000;
}

.is-nav-item:hover{
    color: #A9A9A9;
    text-decoration: underline overline;
}

.nav-divider{
    display: inline-block;
    width: 50%;
    
}

.row-header{
    font-weight: 600;
    color: #363636;
    font-size: 1em;
    line-height: 1.5;
    width: 100%;
    padding: 8px 0px;
    border-bottom: 2px solid #DBDBDB;
}

.row-header-item{
    display: inline-block;
    padding-left: 12px
}

.left{
    width: 28%
}

.middle{
    width: 34%
}

.middle-second{
    width: 10%
}

.right{
    width: 28%
}

.account-container{
    max-height: 500px;
    overflow: auto;
}

@media screen and (max-width: 811px){
    .row-header{
        display: none
    }
}
</style>